/* TJS draft-only adapter: no checkout, order, auth or inventory API. */
(function () {
  'use strict';
  const urls=window.TJS_ASSET_URLS||{};
  const storagePrefix='tjs-harsh-final:theme-'+String(window.TJS_PREVIEW_THEME_ID||'local')+':';
  function asset(value) {
    if(typeof value!=='string'||!value)return value;
    let clean=value.replace(/^\.\//,'').split(/[?#]/)[0];
    if(/^https:\/\//.test(value)) {
      try { const u=new URL(value.replace(/&amp;/g,'&')); clean=(typeof LOCAL_ASSETS!=='undefined'&&LOCAL_ASSETS[u.origin+u.pathname])||value; } catch (_) { return value; }
    }
    const mapped=urls[clean];
    return mapped?new URL(mapped,document.baseURI).href:value;
  }
  function markup(value) {
    return String(value??'').replace(/https:\/\/(?:cdn\.shopify\.com|www\.thejewelrystudio\.us)[^"\s<>]+|(?:\.\/)?assets\/[a-zA-Z0-9_./%?=&;-]+/g,asset);
  }
  const storage={
    getItem:key=>window.localStorage.getItem(storagePrefix+String(key)),
    setItem:(key,value)=>window.localStorage.setItem(storagePrefix+String(key),String(value)),
    removeItem:key=>window.localStorage.removeItem(storagePrefix+String(key))
  };
  function initializeRoute(catalog) {
    if(location.hash&&location.hash!=='#')return;
    const page=window.TJS_NATIVE_PAGE||'index', handle=window.TJS_NATIVE_HANDLE||'';
    let route='';
    if(page==='cart')route='/cart';
    else if(page==='collection'||page==='list-collections'||page==='search') {
      const known=['diamonds','engagement','wedding','jewelry','earrings','necklaces','bracelets','mens-rings'];
      route='/collection/'+(known.includes(handle)?handle:'jewelry');
    } else if(page==='product') {
      const product=catalog.find(p=>p.handle===handle||p.id===handle);
      route=product?'/product/'+product.id:'/review';
    } else if(page==='page') {
      const known=['contact','custom','impact','faq','care','education','journal'];
      route=known.includes(handle)?'/'+handle:'/review';
    } else if(page==='blog'||page==='article')route='/journal';
    else if(page==='404')route='/not-found';
    if(route)history.replaceState(null,'',location.pathname+location.search+'#'+route);
  }
  window.TJSPreview=Object.freeze({asset,markup,storage,storagePrefix,initializeRoute});
}());
